//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    openStats: {
      default: null
    },
    cols: {
      default: 3
    },
    filter: {
      default: null
    },
    url: {
      default: null
    },
    event: {
      default: null
    },
    sport: {
      default: null
    },
    competition: {
      default: null
    }
  },
  methods: {
    isCountryWhitelisted() {
      return _.includes(_.get(this.event, 'stream.countries_whitelisted'), this.IPCountry);
    },
    openStream() {
      if ((this.isTester || this.isCountryWhitelisted()) && _.get(this.event, 'stream.provider') == 'img_arena') {
        this.$store.commit('setStreamingVideo', { 'provider': 'imgarena', 'event_id': _.get(this.event, 'id'), 'event_url': this.url })
      }
    }
  }
}
